import React, { useEffect, useRef, useState } from "react";
import VendorDocumentGrid from "./VendorDocumentGrid";
import {
  Row,
  Col,
  Form,
  Upload,
  Select,
  Space,
  Button,
  message,
} from "antd";
import { Trans, useTranslation } from "react-i18next";
import InputField from "../../common/htmlComponents/InputField";
import { ReactComponent as FileAlt } from "../../image/FileAlt.svg";
import { ReactComponent as FileImageOutlined } from "../../image/FileImageOutlined.svg";
import { DeleteOutlined } from "@ant-design/icons";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import PropTypes from "prop-types";

const VendorDocumentField = ({ VendorId, gstVendorId, gstValue }) => {
  const { t } = useTranslation();
  const [vendorDocumentList, setVendorDocumentList] = useState(null);
  const [addedVendorId, setAddedVendorId] = useState(null);
  const initialDocument = { vendor_company: null, document_name: null };
  const [documentState, setDocumentState] = useState(initialDocument);
  const formRef = useRef(null);
  const [uploadFileOne, setUploadFileOne] = useState("");
  const [fileNameOne, setFileNameOne] = useState(null);
  const [state, setState] = useState({});
  const [sizeOne, setSizeOne] = useState(null);
  const [fileLinkOne, setFileLinkOne] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [vendorDocumentId, setVendorDocumentId] = useState(null);
  const [apiLoading, setapiloading] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;

  let filenameone = "";

  const handleDocumentChange = (e) => {
    let { name, value } = e.target;
    setDocumentState({ ...documentState, [name]: value !== "" ? value : null });
  };

  const uploadPropsOne = {
    accept: ".jpg, .png,.pdf,.jpeg",
    showUploadList: false,
    beforeUpload: (file, name) => {
      setSizeOne(file.size);
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (!allowedTypes.includes(file.type)) {
        message.error("Invalid file type. Only JPG, PNG And PDF are allowed.");
        return Upload.LIST_IGNORE;
      }
      if (file.size <= 2097152) {
        setUploadFileOne(file);
        setFileNameOne(file.name);
      }
      return false;
    },
  };

  const handleDelete = (name) => {
    if (name === "msme_document") {
      setState((prevState) => ({
        ...prevState,
        msme_document: null,
      }));
    } else if (name === "document_url") {
      setState((prevState) => ({
        ...prevState,
        document_url: null,
      }));
      setUploadFileOne("");
      setFileNameOne(null);
      setFileLinkOne(null);
      setSizeOne(null);
    }
  };
  const getCompanyList = async () => {
    setapiloading(true);
    try {
      const apiResponse = await getRequest("company/");
      if (apiResponse.data.results.success) {
        setCompanyList(apiResponse.data.results.data);
      } else {
        ErrorNotificationMsg(t("err_getConcierge"));
      }
      setapiloading(false);
    } catch (error) {
      setapiloading(false);
    }
  };
  const handleFileDelete = async (name) => {
    const apiResponse = await deleteRequest(
      `vendor/${VendorId}/msme-document-delete/`
    );
    if (apiResponse.status) {
      if (name === "msme_document") {
        // ff
      } else if (name === "document_url") {
        setFileNameOne(null);
        setFileLinkOne(null);
        setSizeOne(null);
      }
    }
  };

  const handleEditIconClick = (id) => {
    setVendorDocumentId(id);
  };

  useEffect(() => {
    const getVendorDocument = async () => {
      setapiloading(true);
      try {
        let filenameone1;
        const apiResponse = await getRequest(
          "vendor-document/" + vendorDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          try {
            filenameone1 = apiResponse.data.data.document_url.split("/").pop();
            setFileNameOne(filenameone1);
          } catch (e) {
            filenameone1 = "";
            setFileNameOne(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (vendorDocumentId !== null) {
      getVendorDocument();
    }
    getCompanyList();
  }, [vendorDocumentId, t]);

  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };

  console.log("vendor id", VendorId);
  const handleCompanyChange = (value) => {
    setDocumentState((prevState) => {
      return {
        ...prevState,
        company: value,
      };
    });
  };
  const handleVendorSubmit = async () => {
    const Vendor = VendorId !== null ? VendorId : gstVendorId;
    const payload = {
      vendor: Vendor,
      company: CompanyId !== null ? CompanyId : documentState?.company,
      document_name: documentState.document_name,
    };

    try {
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("document_url", uploadFileOne);
      formData.append("form_data", JSON.stringify(payload));
      if (vendorDocumentId === null) {
        apiResponse = await postRequest(
          "vendor-document/",
          formData,
          customerHeaders
        );
      } else {
        apiResponse = await patchRequest(
          `vendor-document/${vendorDocumentId}/`,
          formData,
          customerHeaders
        );
      }

      if (apiResponse.data.success === true) {
        setVendorDocumentList(apiResponse.data.data);
        handleRefreshGrid();
        SuccessNotificationMsg(
          vendorDocumentId === null
            ? t("document_added_successfully")
            : t("document_updated_successfully")
        );
        setVendorDocumentId(null);
        setDocumentState({ document_name: null });

        formRef.current.setFieldsValue({
          document_name: "",
        });
        setDocumentState((prevState) => ({
          ...prevState,
          document_url: null,
        }));
        setUploadFileOne("");
        setFileNameOne(null);
        setFileLinkOne(null);
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Form autoComplete="off" ref={formRef}>
        <Row gutter={[15]}>
          {authUserData()?.role[0]?.name === "Vendor Admin" && (
            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
              <Form.Item
                name="company"
                label={t("Company")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("Please Select Company")}</Trans>,
                  },
                ]}
              >
                <Select
                  placeholder={t("Select Company")}
                  showArrow
                  showSearch
                  value={documentState?.company}
                  name="company"
                  optionFilterProp="children"
                  onChange={(value) => handleCompanyChange(value)}
                >
                  {companyList.length &&
                    companyList.map((item, key) => {
                      return (
                        <Select.Option key={key} value={item.id}>
                          {item.name}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
            <InputField
              name="document_name"
              className="BrowsButtonSec"
              label={t("pl_document_name")}
              placeholder={t("pl_enter_document_name")}
              handleInputChange={handleDocumentChange}
              prefix={<FileAlt />}
              rules={t("val_document_name")}
              pattern="^[A-Za-z\s]+$"
            />
          </Col>

          <Col
            xs={24}
            sm={24}
            md={12}
            lg={4}
            xl={4}
            className="TextFeild gutter-row"
          >
            <Space>
              <Form.Item
                className="BrowsButtonSec"
                label={t("pl_upload_document")}
                name="document_url"
                rules={[
                  {
                    required: false,
                    message: <Trans>{t("val_file")}</Trans>,
                  },
                ]}
              >
                <Upload
                  className="BrowsButton"
                  {...uploadPropsOne}
                  name="document_url"
                >
                  <Button icon={<FileImageOutlined />}>
                    {t("pl_upload_document")}
                  </Button>
                  <div className="condition">
                    {" "}
                    <p
                      style={{
                        color: sizeOne > 2097152 ? "red" : "GrayText",
                      }}
                    >
                      {t("upload_fileSize")} {t("upload_imagefileType_company")}
                    </p>
                  </div>
                </Upload>

                {sizeOne <= 2097152 && (
                  <>
                    <Space className="uploadedfile" size={[12, 16]}>
                      <a
                        href={fileLinkOne}
                        className="link-color"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {" "}
                        {fileLinkOne ? filenameone : fileNameOne}
                      </a>
                      {fileLinkOne && (
                        <DeleteOutlined
                          onClick={() => handleFileDelete("document_url")}
                        />
                      )}
                      {fileNameOne && (
                        <DeleteOutlined
                          onClick={() => handleDelete("document_url")}
                        />
                      )}
                    </Space>
                  </>
                )}
              </Form.Item>
            </Space>
          </Col>

          <ButtonField
            type="primary"
            className="SaveGradiantBtn verify"
            label={t("send")}
            onClick={() => handleVendorSubmit()}
            loading={btnLoading}
          />
        </Row>
      </Form>

      <VendorDocumentGrid
        refreshGrid={refreshGrid}
        vendorDocumentList={vendorDocumentList}
        setVendorDocumentList={setVendorDocumentList}
        addedVendorId={addedVendorId}
        onEditIconClick={handleEditIconClick}
        VendorId={VendorId}
        gstVendorId={gstVendorId}
        gstValue={gstValue}
      />
    </>
  );
};

VendorDocumentField.propTypes = {
  VendorId: PropTypes.number,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
};

export default VendorDocumentField;
